// extracted by mini-css-extract-plugin
export default {"pageFrame":"pageFrame-Puy0l","header":"header-TtdL4","goBackLabel":"goBackLabel-Nu7rK","title":"title-KYWVO","subtitle":"subtitle-eF0vR"};